import script from "./ChildBookingInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChildBookingInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ChildBookingInfo.vue?vue&type=style&index=0&id=6f466390&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f466390"]])

export default __exports__